import BadRequestError from '@errors/BadRequestError'
import { csrfToken } from './csrfToken'
import fetchApi from './fetchApi'

interface JsonApiOptions<TBad> {
  signal?: AbortSignal
  onBadRequest?: (body: TBad) => void
}

const jsonApi = <TOk = unknown, TBad = unknown>(
  url: string,
  method: 'get' | 'post' | 'put' | 'patch' | 'delete',
  params?: unknown,
  opts?: JsonApiOptions<TBad>
): Promise<TOk> => {
  const headers: HeadersInit =
    method === 'get' ? {} : { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken() }
  const promise = fetchApi<TOk>(url, {
    method,
    headers,
    body: method === 'get' ? undefined : JSON.stringify(params),
    signal: opts?.signal,
  })
  const onBadRequest = opts?.onBadRequest
  if (!onBadRequest) return promise
  return promise.catch((e) => {
    if (e instanceof BadRequestError) onBadRequest(e.body as TBad)
    throw e
  })
}

export default jsonApi
